<template>
  <div id="Step1" v-if="product">
    <!-- Make a gift -->
    <div class="wwf-checkbox" v-if="product.producttype == 'adoption'">
      <label>
        Make this a gift for someone
        <input
          type="checkbox"
          id="isGift-step-1"
          name="isGift"
          v-model="donation.isGift"
        />
        <span class="checkbox"></span>
      </label>
    </div>
    <!-- /Make a gift -->

    <!-- Package -->
    <h2
      v-if="packages.length > 1 && product.producttype != 'wildcard'"
    >{{ donation.isGift ? 'Select your adoption pack to gift to someone' : 'Select your pack'}}</h2>
    <div class="wwf-radio-bttns" v-if="packages.length > 1 && product.producttype != 'wildcard'">
      <label :for="'package-'+item.code" v-for="(item, index) in packages">
        {{item.display}}
        <input
          type="radio"
          v-validate="'required'"
          v-model="donation.packagecode"
          name="package"
          :value="item.code"
          :checked="index==0 ? 'checked' : ''"
          :id="'package-'+item.code"
        />
        <span class="wwf-radio"></span>
      </label>
      <span class="wwf-alert">
        <p v-if="errors.first('package')">Please choose your pack</p>
      </span>
    </div>
    <div class="wwf-packs" v-if="packages.length > 0 && product.producttype != 'wildcard'">
      <div class="packs">
        <div
          class="pack"
          v-if="packages.find(x => x.code==donation.packagecode)!=null && packages.find(x => x.code==donation.packagecode).pack!=null"
          :style="'background-image:url('+packages.find(x => x.code==donation.packagecode).pack.image+')'"
        ></div>
        <div
          class="toy"
          :class="packages.find(x => x.code==donation.packagecode)!=null && packages.find(x => x.code==donation.packagecode).toy!=null ? 'has-toy' : 'has-no-toy'"
          :style="packages.find(x => x.code==donation.packagecode)!=null && packages.find(x => x.code==donation.packagecode).toy!=null ? 'background-image:url('+packages.find(x => x.code==donation.packagecode).toy.image+')' : ''"
        ></div>
      </div>
      <div class="message">
        <p>
          <span
            v-if="packages.find(x => x.code==donation.packagecode)!=null && packages.find(x => x.code==donation.packagecode).pack!=null"
          >{{packages.find(x => x.code==donation.packagecode).pack.text}}</span>
          <span
            v-if="packages.find(x => x.code==donation.packagecode)!=null && packages.find(x => x.code==donation.packagecode).toy!=null"
          >{{packages.find(x => x.code==donation.packagecode).toy.text}}</span>
        </p>
      </div>
    </div>
    <!-- /Package -->

    <!-- Package WildCard -->
    <h2
      v-if="product.packages && product.packages.length > 1 && product.producttype == 'wildcard'"
    >Choose your design</h2>
    <div
      class="wwf-packs wildcard--select"
      v-if="product.packages && product.packages.length > 1 && product.producttype == 'wildcard'"
    >
      <label :for="'package-'+item.code" v-for="(item, index) in product.packages">
        <input
          type="radio"
          v-validate="'required'"
          v-model="donation.packagecode"
          name="package"
          :value="item.code"
          :checked="index==0 ? 'checked' : ''"
          :id="'package-'+item.code"
        />
        <img :src="item.img" class="tooltipstered" style="margin-bottom: 15px;" />
        <span class="wwf-radio"></span>
      </label>
      <span class="wwf-alert">
        <p v-if="errors.first('package')">Please choose your design</p>
      </span>
    </div>
    <!-- /Package -->

    <!-- Dollar Handles -->
    <!-- Select between the available types (Single, Regular, ...) -->
    <div
      class="wwf-radio-bttns donation-type-tabs"
      :class="{ 'single-tabs': product.donationtypes.length === 1 }"
    >
      <label
        class="donation-type-tab"
        :for="'selection-' + donationtype"
        v-for="(donationtype, index) in product.donationtypes"
      >
        {{ (donationtype == "Regular") ? 'Give monthly' : 'Give once' }}
        <input
          type="radio"
          v-validate="'required'"
          v-model="selectedDonationType"
          name="selectedDonationType"
          :value="donationtype"
          :checked="index == 0 ? 'checked' : ''"
          :id="'selection-' + donationtype"
        />
        <span class="wwf-radio"></span>
      </label>

      <span class="wwf-tooltip">
        <p>Donations of $2 or more are tax deductible. For adoptions, the toy value cannot be claimed as a tax deductible gift.</p>
      </span>
    </div>

    <!-- List of handles for the selected type -->
    <div
      class="dollar-handles"
      v-for="donationtype in product.donationtypes"
      v-if="donation.type == donationtype"
    >
      <label
        :for="'handle-' + donationtype + '-' + index.amount"
        v-for="index in product.dollarhandles[donationtype]"
      >
        <input
          type="radio"
          v-validate="'required'"
          v-model="donation.dollarhandle"
          :name="'handle-' + donationtype"
          :value="index.amount"
          :id="'handle-' + donationtype + '-' + index.amount"
          data-vv-as="amount"
        />
        <span class="amount" :class="{'has-cents': !(index.amount.indexOf('.00') >= 0)}">
          <span>${{ (index.amount.indexOf('.00') >= 0) ? index.amount.slice(0,-3) : index.amount}}</span>
        </span>
        <span class="handle"></span>
        <span class="svg-circle">
          <svg style="width:100%;height:100%;">
            <circle cx="50%" cy="50%" r="40%" stroke-width="3" />
          </svg>
        </span>
      </label>

      <!-- Custom amount -->
      <label v-if="!(product.extrasetting && product.extrasetting.hidecustomhandle)">
        <input
          type="radio"
          v-model="donation.dollarhandle"
          @click="setFocus()"
          :name="'handle-' + donationtype"
          value="custom"
          :id="'handle-custom-' + donationtype"
        />
        <span class="amount">
          <i class="fas fa-pencil-alt"></i>
        </span>
        <span class="handle"></span>
        <span class="svg-circle">
          <svg style="width:100%;height:100%;">
            <circle cx="50%" cy="50%" r="40%" stroke-width="3" />
          </svg>
        </span>
      </label>

      <!-- TODO focus when select pencil -->
      <div
        class="field other-amount-form"
        v-show="donation.dollarhandle=='custom'"
        :class="donation.amount ? 'has-content' : ''"
      >
        <input
          type="tel"
          ref="customhandle"
          name="custom-handle"
          id="custom-handle"
          v-validate="{required: true, donationAmountIsValid: true, regex: /^\d+(\.\d{1,2})?$/}"
          v-model="donation.amount"
          :class="{'border-red': errors.has('custom-handle')}"
          placeholder="Choose an amount"
          data-vv-as="amount"
          @input="checkMaxAmount()"
        />
        <label for="custom-handle">Choose an amount</label>
        <span class="wwf-alert">
          <p
            v-if="errors.firstByRule('custom-handle','donationAmountIsValid')"
          >{{errors.first('custom-handle')}}</p>
        </span>
      </div>

      <!-- Message for big amount -->
      <div class="message-big-amount" v-show="maxAmount">
        <p>
          For donations above $75,000 please contact our Impact Partnerships team, so we can be sure your gift benefits the area of conservation you are most passionate about. 
        </p>
        <p>
          Please email  <a href="mailto:partnerships@wwf.org.au" target="_blank">partnerships@wwf.org.au</a>. Thank you so much for your kindness!
        </p>
      </div>

      <!-- Dollar Handle Description -->
      <div
        v-if="donation.dollarhandle!=null && donation.dollarhandle!='custom' && donation.dollarhandle!=''"
        class="dollar-handles-desc"
        :class="{'has-amount': (donation.dollarhandle != null ) , 'addToolPos-': false }"
      >
        <p>{{product.dollarhandles[donationtype].find(x => x.amount == donation.dollarhandle) ? product.dollarhandles[donationtype].find(x => x.amount == donation.dollarhandle).text : ""}}</p>
      </div>

      <span class="wwf-alert">
        <p v-if="errors.first('handle-' + donationtype)">Please choose your donation amount</p>
      </span>

      <tax-calculator
        :amount="donation.amount"
        v-if="donation.amount && product.extrasetting && product.extrasetting.displaytaxcalculator"
      ></tax-calculator>
    </div>
    <!-- /dollar handles -->

    <h2>Enter your email</h2>
    <div class="field" :class="donation.email ? 'has-content' : ''">
      <input
        type="email"
        name="email"
        id="email"
        v-model="donation.email"
        v-validate="{ required: true, donationCheckEmail: true }"
        :class="{'border-red': errors.has('email') || errors.has('donationCheckEmail') }"
        placeholder="Email"
        autocomplete="email"
      />
      <div class="input-loading" v-if="checkEmailLoading">
        <img src="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3519/dist/assets/img/loading-tail-spin.svg" />
      </div>
      <label for="email">Email {{ errors.firstByRule('email', 'required') ? 'required' : '' }}</label>

      <span class="wwf-alert">
        <p v-if="errors.firstByRule('email', 'donationCheckEmail')">{{errors.first('email')}}</p>
      </span>
    </div>
    <div checked="checked" class="wwf-checkbox">
      <label>
        Send me emails about important conservation news and how I can help WWF protect the diversity of life on Earth.
        <input
          type="checkbox"
          id="opt-in-step-1"
          name="opt-in"
          v-model="donation.optin"
        />
        <span class="checkbox"></span>
      </label>
    </div>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import TaxCalculator from "../TaxCalculator.vue";
import { getNameByDonationType } from "../../helpers";
import gtm from "../../utils/gtm";

import { mapState } from "vuex";

export default {
  components: {
    TaxCalculator
  },
  data() {
    return {
      maxAmount: false,
      timeout: null,
      lastTimestamp: Date.now(),
      emailRegex: /.+\@.+\..+/,
      checkEmailLoading: false
    };
  },
  props: {
    useNewCheckout: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    // Custom validation for amount (regular/single)
    let donationAmountIsValid = amount => {
      if (amount <= 0) {
        return {
          valid: false,
          data: { message: "The amount is invalid" }
        };
      };

      // Get the min amount from the settings of the selected type or the default one if not set
      const customMinAmount = this.product.donationsettings[this.donation.type] ? this.product.donationsettings[this.donation.type].minimumAmount : undefined;
      const minimumAmount = customMinAmount ? parseFloat(customMinAmount) : (this.type === "Regular" ? 15 : 2);
      const inputAmount = parseInt(this.donation.amount.replace(/ /g,''));
      if (amount < minimumAmount) {
        return {
          valid: false,
          data: { message: "The minimum amount is $" + minimumAmount }
        };
      } else if (inputAmount > 75000) {
        return {
          valid: false,
          data: { message: "The maximum amount is $75,000" }
        };
      } else {
        return {
          valid: true
        };
      }
    };

    Validator.extend("donationAmountIsValid", {
      validate: donationAmountIsValid,
      getMessage: (field, params, data) => data.message
    });

    const donationCheckEmail = email => {
      if (email.length > 0 && this.emailRegex.test(email)) {
        return new Promise((resolve, reject) => {
          let timestamp = Date.now(); // timestamp for this api call
          this.lastTimestamp = timestamp; // 1 , 2 , 3
          this.checkEmailLoading = true;
          // Fetch Suggestions
          this.$store
            .dispatch("validateEmail", email)
            .then((response) => {
              if (response && timestamp >= this.lastTimestamp) {
                this.checkEmailLoading = false;
                this.donation.emailValidation = response;
                resolve(response);
              }
            })
            .catch((err) => {
              console.error(err);
              this.checkEmailLoading = false;
              // If the call failed, do not keep the user from donating
              resolve({
                valid: true
              });
            });
        })
      } else {
        return {
          valid: false,
          data: { message: "Email invalid" }
        };
      }
    }

    Validator.extend("donationCheckEmail", {
      validate: donationCheckEmail,
      getMessage: (field, params, data) => data.message
    });
  },
  computed: {
    selectedDonationType: {
      get() {
        return this.donation.type;
      },
      set(newType) {
        this.maxAmount = false;

        this.$store.commit("updateDonation", { field: "type", value: newType });

        // Reset any previous selection like if it was new
        this.$store.commit("updateDonation", {
          field: "dollarhandle",
          value: ""
        });
        this.$store.commit("updateDonation", {
          field: "amount",
          value: ""
        });

        // Update the Campaign ID and the Fund ID with the one of the selected Donation Type
        const settings = this.product.donationsettings[newType];
        if (settings) {
          this.$store.commit("updateDonation", {
            field: "campaignid",
            value: settings.campaignid
          });
          this.$store.commit("updateDonation", {
            field: "fundid",
            value: settings.fundid
          });
        }
      }
    },
    ...mapState({
      donation: state => state.donation.donation,
      dollarhandle: state => state.donation.donation.dollarhandle,
      type: state => state.donation.donation.type,
      packagecode: state => state.donation.donation.packagecode,
      product: state => state.product.product,
      packages: state => state.product.packagesProduct
    })
  },
  watch: {
    // When the dollar handle changed update the amount
    dollarhandle: function(newValue, oldValue) {
      this.donation.amount = newValue == "custom" ? null : newValue;
    },
    // When the packagecode changed update the img and pdf for wildcard (TODO)
    packagecode: function(newValue, oldValue) {
      console.log("packagecode changed", newValue);
      if (this.product.producttype == "wildcard") {
        console.log("packagecode wilcard", this.product.packages);
        this.donation.wildcard.img = this.product.packages.find(
          x => x.code == newValue
        ).img;
        this.donation.wildcard.pdf = this.product.packages.find(
          x => x.code == newValue
        ).pdf;
      }
    }
  },
  methods: {
    setFocus: function() {
      setTimeout(
        function() {
          this.$refs.customhandle[0].focus();
        }.bind(this),
        500
      );
    },
    checkMaxAmount: function() {
      const inputAmount = parseInt(this.donation.amount.replace(/ /g,''));
      if (inputAmount > 75000) {
        this.maxAmount = true;
      } else {
        this.maxAmount = false;
      }
    },
    validate: function() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then(result => {
          if (!result) {
            console.log("The form on step1 product is invalid");
            reject("The form on step1 product is invalid");
          } else {
            console.log("The form on step1 product is valid");

            // Add .00 if no . and add 0 if no 0 (eg 42.6)
            this.donation.amount =
              this.donation.amount.indexOf(".") == -1
                ? this.donation.amount.concat(".00")
                : /^\d+(\.\d{1})+$/.test(this.donation.amount)
                ? this.donation.amount.concat("0")
                : this.donation.amount;

            this.$store.dispatch("saveDonationStep1").then(response => {
                // GTM: Push datalayer add to cart
                gtm.pushAddToCart(
                  this.product.productname,
                  this.product.id,
                  this.donation.amount,
                  this.product.producttype,
                  getNameByDonationType(this.donation.type)
                );

                if (!this.useNewCheckout) {
                    this.$store
                      .dispatch("checkout")
                      .then(checkoutResponse => {
                        console.log("mounted: ", checkoutResponse);
                        resolve();
                      });
                } else {
                  resolve();
                }
              }).catch(error => {
                console.error("saveDonation1 error", error);
                reject(error);
              }
            );
          }
        });
      });
    }
  }
};
</script>

<style scoped>

/* TOOLTIPS */

span.wwf-tooltip {
  display: inline-block;
  width: 17px;
  height: 17px;
  background-color: var(--wwfGreyF3);
  border-radius: 50%;
  vertical-align: middle;
  line-height: 0;
  text-align: center;
  padding-top: 2px;
  box-shadow: 0 1px 0px rgba(0, 0, 0, 0.1);
  margin-left: 3px;
  position: relative;
  z-index: 9999;
}

span.wwf-tooltip:before {
  content: '?';
  font-family: 'Arial';
  font-size: 13px;
  font-weight: 900;
  color: var(--primaryColor);
  line-height: normal;
  display: block;
}

span.wwf-tooltip p {
  position: absolute;
  width: 220px;
  background-color: var(--wwfGrey47);
  color: var(--wwfWhite);
  font-size: 13px;
  line-height: normal;
  z-index: 999999;
  bottom: 25px;
  right: -20px;
  padding: 10px;
  border-radius: 10px;
  text-align: left;
  pointer-events: none;
  opacity: 0;
  -webkit-transform: translateY(-20px);
  transform: translateY(-20px) scale(1.05);
  transform-origin: center;
}

span.wwf-tooltip p:after {
  content: '';
  position: absolute;
  right: 22px;
  margin: 0 auto;
  width: 20px;
  height: 20px;
  background-color: var(--wwfGrey47);
  transform: rotate(45deg);
  border-radius: 7px;
  bottom: 6px;
  transform-origin: bottom left;
  z-index: -1;
}

span.wwf-tooltip:hover p {
  opacity: 1;
  -webkit-transform: translateY(0px);
  transform: translateY(0px);
}

.DOB span.wwf-tooltip {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}

h2 span.wwf-tooltip {
  position: absolute;
  right: -25px;
  top: 50%;
  margin-top: -5px;
  line-height: normal;
}

p.address-bttn {
  margin-top: -15px;
  margin-bottom: 10px;
}

.donation-type-tabs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 16px;
}

.donation-type-tab {
  padding: 8px 16px;
  padding-left: 30px;
  margin: 0;
  color: var(--wwfBlack);
  text-align: center;
  white-space: nowrap;
  font-size: 34px;
  font-family: "WWFRegular", sans-serif;
  cursor: pointer;
  transition: border 0.5s, padding 0ms;
  transition: color 200ms;
}

.donation-type-tab .wwf-radio {
  top: 42px;
}

.wwf-tooltip {
  margin-left: -25px;
  padding-top: 0px;
}

.single-tabs .wwf-tooltip {
  margin-left: 0px;
}

.single-tabs .wwf-radio {
  display: none;
}

.single-tabs .donation-type-tab {
  padding: 0px 16px;
}

@media (max-width: 790px) {
  .donation-type-tab {
    font-size: 28px;
  }

  .donation-type-tab .wwf-radio {
    top: 35px;
  }
}

@media (max-width: 720px) {
  .donation-type-tab {
    font-size: 24px;
  }

  .donation-type-tab .wwf-radio {
    top: 30px;
  }
}

@media (max-width: 640px) {
  .donation-type-tab {
    font-size: 34px;
  }

  .donation-type-tab .wwf-radio {
    top: 42px;
  }
}

@media (max-width: 410px) {
  .donation-type-tab {
    font-size: 28px;
  }

  .donation-type-tab .wwf-radio {
    top: 35px;
  }
}

@media (max-width: 350px) {
  .donation-type-tab {
    font-size: 22px;
  }

  .donation-type-tab .wwf-radio {
    top: 30px;
  }
}

.message-big-amount {
  margin-top: 8px;
}

.message-big-amount p {
  margin-bottom: 8px;
  font-size: 15px;
}

/* TOOLTIPS */

span.wwf-tooltip {
  display: inline-block;
  width: 17px;
  height: 17px;
  background-color: var(--wwfBg);
  border-radius: 50%;
  vertical-align: middle;
  line-height: 0;
  text-align: center;
  padding-top: 2px;
  box-shadow: 0 1px 0px rgba(0, 0, 0, 0.1);
  margin-left: 3px;
  position: relative;
  z-index: 9999;
}

span.wwf-tooltip:before {
  content: '?';
  font-family: 'Arial';
  font-size: 13px;
  font-weight: 900;
  color: var(--primaryColor);
  line-height: normal;
  display: block;
}

span.wwf-tooltip p {
  position: absolute;
  width: 220px;
  background-color: var(--wwfGrey47);
  color: var(--wwfWhite);
  font-size: 13px;
  line-height: normal;
  z-index: 999999;
  bottom: 25px;
  right: -20px;
  padding: 10px;
  border-radius: 10px;
  text-align: left;
  pointer-events: none;
  opacity: 0;
  -webkit-transform: translateY(-20px);
  transform: translateY(-20px) scale(1.05);
  transform-origin: center;
}

span.wwf-tooltip p:after {
  content: '';
  position: absolute;
  right: 22px;
  margin: 0 auto;
  width: 20px;
  height: 20px;
  background-color: var(--wwfGrey47);
  transform: rotate(45deg);
  border-radius: 7px;
  bottom: 6px;
  transform-origin: bottom left;
  z-index: -1;
}

span.wwf-tooltip:hover p {
  opacity: 1;
  -webkit-transform: translateY(0px);
  transform: translateY(0px);
}

.DOB span.wwf-tooltip {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}

h2 span.wwf-tooltip {
  position: absolute;
  right: -25px;
  top: 50%;
  margin-top: -5px;
  line-height: normal;
}
 
/* SELECT OTHER AMOUNT */

.other-amount input {
  position: relative;
  height: 92px;
  z-index: 2;
  background-color: transparent;
  border: 0;
  font-family: 'wwfRegular';
  color: var(--wwfWhite);
  font-size: 64px;
  padding: 0;
  text-align: center;
  line-height: 50px;
  margin-bottom: 0;
  box-shadow: none;
  cursor: pointer;
  top: -20px;
}

.other-amount input:focus {
  background-color: transparent;
  border: 0;
  box-shadow: none;
  cursor: text;
}

.other-amount .pencil {
  position: absolute;
  top: 0;
  z-index: 1;
  text-align: center;
  left: 0;
  right: 0;
  width: 90px;
  margin: 0 auto;
  font-family: 'wwfRegular';
  color: var(--wwfWhite);
  font-size: 64px;
  pointer-events: none;
  height: 100%;
  transition: .4s ease;
  padding-left: 30px;
  padding-right: 30px;
}

.other-amount input:focus~.pencil,
.other-amount.has-other-content input~.pencil {
  width: 100%;
}

.other-amount {
  position: relative;
  overflow: hidden;
  height: 72px;
}

.other-amount .pencil:before {
  content: '$';
  position: absolute;
  left: 0;
  height: 100%;
  line-height: 50px;
  transform: scale(0);
  transition: .3s ease;
}

.other-amount input:focus~.pencil:before,
.other-amount.has-other-content input~.pencil:before {
  transform: scale(1);
  transition-delay: .3s;
}

.other-amount .pencil span {
  position: absolute;
  bottom: 0px;
  left: 0;
  right: 0;
  width: 0%;
  margin: 0 auto;
  content: '';
  position: absolute;
  -webkit-transition: .3s ease;
  transition: .3s ease;
  border-bottom: 10px dotted white;
}

.other-amount input:focus~.pencil span,
.other-amount.has-other-content input~.pencil span {
  width: 100%;
}

.other-amount .pencil i {
  position: absolute !important;
  right: 22px;
  -webkit-transform-origin: left bottom;
  transform-origin: left bottom;
}

.other-amount input:focus~.pencil i,
.other-amount.has-other-content input~.pencil i {
  -webkit-animation: animatePencil .3s 2 ease;
  animation: animatePencil .3s 2 ease;
  right: 0;
}

@-webkit-keyframes animatePencil {
  0% {
    -webkit-transform: rotate(0deg)
  }

  50% {
    -webkit-transform: rotate(10deg)
  }

  100% {
    -webkit-transform: rotate(0deg)
  }
}

@keyframes animatePencil {
  0% {
    transform: rotate(0deg)
  }

  50% {
    transform: rotate(10deg)
  }

  100% {
    transform: rotate(0deg)
  }
}

/* OTHER AMOUNT FORM */

.other-amount-form input[type="tel"] {
  width: calc(100% - 40px);
  display: inline-block;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: none;
}

.field.other-amount-form:before {
  content: '$';
  position: absolute;
  left: 0;
  width: 40px;
  height: 45px;
  background-color: var(--primaryColor);
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  color: var(--wwfWhite);
  content: '$';
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  padding: 5px;
}

.other-amount-form.field.has-content label,
.other-amount-form.field label,
.other-amount-form.field label:focus {
  left: 50px !important;
}

/* DOLLAR HANDLE */

.dollar-handles-desc {
  background-color: var(--primaryColor);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  padding: 15px;
  border-radius: 15px;
  margin-top: 15px;
  margin-bottom: 15px;
  z-index: 3;
  position: relative;
  font-weight: 600;
  color: var(--wwfWhite);
}

.dollar-handles-desc p {
  margin-bottom: 0;
  line-height: 17px;
  font-size: 15px;
}

.dollar-handles-desc span {
  display: block;
  width: 100%;
  height: 0px;
  position: absolute;
  top: 0;
  left: 0;
  background-color: inherit;
}

.dollar-handles-desc span:before {
  position: absolute;
  content: '';
  width: 25px;
  height: 25px;
  background-color: inherit;
  top: -22px;
  left: 25px;
  border-radius: 6px;
  transform: rotate(45deg);
  transform-origin: bottom left;
  background-color: inherit;
  transition: .5s .5s ease;
}

@media only screen and (max-width: 40em) {
  .dollar-handles-desc span:before {
    width: 15px;
    height: 15px;
    top: -14px;
    left: 15px;
    border-radius: 3px;
  }
}

.addToolPos-1 span:before {
  left: calc(0% - -25px);
}

.addToolPos-2 span:before {
  left: calc(20% - -25px);
}

.addToolPos-3 span:before {
  left: calc(40% - -25px);
}

.addToolPos-4 span:before {
  left: calc(60% - -25px);
}

.addToolPos-5 span:before {
  left: calc(80% - -25px);
}

@media only screen and (max-width: 40em) {

  .addToolPos-1 span:before {
    left: calc(0% - -15px);
  }

  .addToolPos-2 span:before {
    left: calc(20% - -15px);
  }

  .addToolPos-3 span:before {
    left: calc(40% - -15px);
  }

  .addToolPos-4 span:before {
    left: calc(60% - -15px);
  }

  .addToolPos-5 span:before {
    left: calc(80% - -15px);
  }
}

/* PACKS */

.wwf-packs {
  width: 100%;
  position: relative;
}

.wwf-packs .packs {
  width: calc(100% - -40px);
  margin-left: -20px;
  height: 0;
  padding-top: 85%;
  background-color: var(--wwfGreyE4);
  position: relative;
  overflow: hidden;
  background: -moz-linear-gradient(top, rgba(211, 211, 211, 1) 0%, rgba(242, 242, 242, 1) 49%, rgba(214, 214, 214, 1) 65%, rgba(239, 239, 239, 1) 100%);
  /* FF3.6-15 */
  background: -webkit-linear-gradient(top, rgba(211, 211, 211, 1) 0%, rgba(242, 242, 242, 1) 49%, rgba(214, 214, 214, 1) 65%, rgba(239, 239, 239, 1) 100%);
  /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to bottom, rgba(211, 211, 211, 1) 0%, rgba(242, 242, 242, 1) 41%, rgba(214, 214, 214, 1) 55%, rgba(239, 239, 239, 1) 100%);
  /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
}

.wwf-packs .packs:before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(41, 30, 3, 0.02);
  background: -moz-radial-gradient(center, ellipse cover, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 22%, rgba(0, 0, 0, 1) 100%);
  /* FF3.6-15 */
  background: -webkit-radial-gradient(center, ellipse cover, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 22%, rgb(0, 0, 0) 100%);
  /* Chrome10-25,Safari5.1-6 */
  background: radial-gradient(ellipse at center, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 22%, rgb(0, 0, 0) 100%);
  /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  opacity: .06;
  z-index: 3;
}

.wwf-packs .packs .pack,
.wwf-packs .packs .toy {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 1;
  background-size: auto 100%;
  background-position: 85% 50%;
  background-repeat: no-repeat;
}

.wwf-packs .packs .toy {
  z-index: 2;
  width: 40%;
  height: 50%;
  top: initial;
  bottom: 5%;
  right: -5% !important;
  left: initial;
  opacity: 0;
  transform: translateY(-25px);
  transform-origin: bottom;
  background-size: 100% auto;
  background-repeat: no-repeat;
}

.wwf-packs .packs .toy.has-toy {
  animation: addToy .7s .1s ease-in-out forwards;
}

.wwf-packs .packs .toy.has-no-toy {
  animation: removeToy .6s .1s ease-in-out forwards;
}

@keyframes addToy {
  0% {
    opacity: 0;
    transform: translateY(-25px);
  }

  35% {
    opacity: 1;
    transform: translateY(-25px);
  }

  60% {
    opacity: 1;
    transform: translateY(0px) scaleY(.99);
  }

  80% {
    opacity: 1;
    transform: translateY(-4px) scaleY(1);
  }

  100% {
    opacity: 1;
    transform: translateY(0px) scaleY(1);
  }
}

@keyframes removeToy {
  0% {
    opacity: 1;
    transform: translateY(0px);
  }

  20% {
    opacity: 1;
    transform: translateY(0px) scaleY(.9);
  }

  60% {
    opacity: 1;
    transform: translateY(-35px) scaleY(1);
  }

  80% {
    opacity: 0;
    transform: translateY(-35px) scaleY(1);
  }
}

.wwf-packs .message p {
  margin-bottom: 0;
  line-height: 17px;
  color: var(--wwfWhite);
  font-size: 15px;
}

.wwf-packs .message:before {
  position: absolute;
  content: '';
  width: 25px;
  height: 25px;
  background-color: inherit;
  top: -22px;
  left: 25px;
  border-radius: 6px;
  transform: rotate(45deg);
  transform-origin: bottom left;
}

/* WILDCARDS */

.wwf-packs.wildcard--select label .wwf-radio {
  display: none;
}

.wwf-packs.wildcard--select label input[type="radio"] {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.wwf-packs.wildcard--select label img,
.wilcards--selected img {
  width: 100%;
  border: 5px solid white;
  border-radius: 3px;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2), 0 2px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 0 !important;
}

.wilcards--selected img {
  margin-bottom: 15px !important;
}

.wwf-packs.wildcard--select label input[type="radio"]:checked~img {
  border: 5px solid var(--primaryColor);
}

.wwf-packs.wildcard--select label {
  position: relative;
  margin-bottom: 15px;
}

.wwf-packs.wildcard--select label .wwf-radio {
  display: none;
}
</style>


// WEBPACK FOOTER //
// Step1.vue?64dea969